import { Component } from '@angular/core';
import { MenuComponentBase } from '../../../../shared/base-classes/menu-component-base';
import { DocumentTableComponent } from '../document-table/document-table.component';

@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [DocumentTableComponent],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss',
})
export class DocumentsComponent extends MenuComponentBase {}
